import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import ClaimJobDataPointsInputs, {
  getVisibleDataPoints,
} from 'module/claims/views/claim/other/Claim.Job.DataPoints.Inputs';
import { ClaimJobForm } from '../ClaimEdit.Job.Form';

const ClaimEditJobFormDataPoints = () => {
  const { form } = useModalForm<ClaimJobForm>();

  const updateValue = (value: string, id: number) => {
    const updatedDataPoints = form.data?.dataPoints?.map((item) =>
      id === item?.claimTypeDataPointId ? { ...item, value } : item
    );
    form.update({ dataPoints: updatedDataPoints });
  };

  return (
    <FormWrapper>
      <ClaimJobDataPointsInputs dataPoints={getVisibleDataPoints(form.data?.dataPoints)} onUpdate={updateValue} />
    </FormWrapper>
  );
};

export default ClaimEditJobFormDataPoints;
